"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChatHeader = void 0;
const lit_1 = require("lit");
const decorators_js_1 = require("lit/decorators.js");
let ChatHeader = class ChatHeader extends lit_1.LitElement {
    render() {
        return (0, lit_1.html) `
      <slot></slot>
    `;
    }
};
ChatHeader.styles = (0, lit_1.css) `
    :host {
      display: block;
      width: 100%;
      max-width: var(--layout-width-small);
      flex-shrink: 0;
      margin: 0 auto;
      padding: var(--space-3) var(--space-4);
      box-sizing: border-box;
    }

    :host(:empty) {
      display: none;
    }
  `;
ChatHeader = __decorate([
    (0, decorators_js_1.customElement)('mm-chat-header')
], ChatHeader);
exports.ChatHeader = ChatHeader;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY2hhdC1oZWFkZXIuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJjaGF0LWhlYWRlci50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7QUFBQSw2QkFBMkM7QUFDM0MscURBQWlEO0FBRzFDLElBQU0sVUFBVSxHQUFoQixNQUFNLFVBQVcsU0FBUSxnQkFBVTtJQWlCeEMsTUFBTTtRQUNKLE9BQU8sSUFBQSxVQUFJLEVBQUE7O0tBRVYsQ0FBQTtJQUNILENBQUM7O0FBcEJNLGlCQUFNLEdBQUcsSUFBQSxTQUFHLEVBQUE7Ozs7Ozs7Ozs7Ozs7O0dBY2xCLENBQUE7QUFmVSxVQUFVO0lBRHRCLElBQUEsNkJBQWEsRUFBQyxnQkFBZ0IsQ0FBQztHQUNuQixVQUFVLENBc0J0QjtBQXRCWSxnQ0FBVSJ9